<template>
  <div>
    <form
      @submit.prevent="onSubmit"
      novalidate
      enctype="multipart/form-data"
      :class="submitted ? 'needs-validation was-validated' : 'needs-validation'"
    >
      <input
        type="hidden"
        name="csrfmiddlewaretoken"
        value="QpNzWEVJfpFnOe6Ii3yEfIs7Spl96BRuCdjIkRH2uRMab9tKbpCwgG0ctqBludYL"
      />

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <p></p>
              <div class="text-center text-primary my-2" v-if="loading">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template v-if="!loading">
                <div class="row">
                  <div class="col-lg-6">
                    <label for="opportunity_name_id">Opportunity Name*</label>
                    <input
                      type="text"
                      name="opportunity_name"
                      id="opportunity_name_id"
                      class="form-control"
                      v-model.trim="$v.opportunity_name.$model"
                      required=""
                    />
                    <div
                      v-if="submitted && !$v.opportunity_name.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <label for="tags_id">Tags</label>
                    <b-button
                      class="btn btn-primary btn-xs float-end"
                      id="show-btn"
                      v-b-modal.tag-create
                      >Create Tag</b-button
                    >
                    <vue-tags-input
                      @focus="openDefault = true"
                      @blur="onBlur"
                      v-model.trim="tag"
                      :tags="tags"
                      :add-only-from-autocomplete="true"
                      :autocomplete-items="filteredItems"
                      :autocomplete-always-open="openDefault"
                      @tags-changed="(newTags) => (tags = newTags)"
                    />
                  </div>
                </div>
                <template v-if="step === 99 || isEdit">
                  <p></p>
                  <div class="row">
                    <div class="col-lg-6">
                      <label for="broker_name">Broker Name</label>
                      <input
                        type="text"
                        name="broker_name"
                        id="broker_name_id"
                        class="form-control"
                        v-model.trim="broker_name"
                      />
                    </div>
                    <div class="col-lg-6">
                      <label for="broker_fee">Broker Fee</label>
                      <input
                        type="number"
                        name="broker_fee"
                        id="broker_fee_id"
                        class="form-control"
                        v-model.trim="broker_fee"
                      />
                    </div>
                  </div>
                  <p></p>

                  <div class="row">
                    <div class="col-12 col-lg-6">
                      <label for="sales_annual_volume_manual"
                        >Annual Volume</label
                      >
                      <input
                        type="number"
                        name="sales_annual_volume_manual"
                        id="sales_annual_volume_manual_id"
                        class="form-control"
                        v-model.trim="sales_annual_volume_manual"
                      />
                      <p></p>
                    </div>
                    <div class="col-12 col-lg-6">
                      <label for="sales_represented"
                        >Sales Person Represented</label
                      >
                      <input
                        type="text"
                        name="sales_represented"
                        id="sales_represented_id"
                        class="form-control"
                        v-model.trim="sales_represented"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <label for="credit_request_id">Credit Request</label>
                      <select
                        name="credit_request"
                        id="credit_request_id"
                        class="form-select"
                        v-model.trim="credit_request"
                      >
                        <option value="no" selected="">No</option>

                        <option value="yes">Yes</option>
                      </select>
                    </div>
                    <div class="col-lg-6">
                      <label for="pricing_due_date_id">Pricing Due Date</label>
                      <input
                        type="date"
                        name="pricing_due_date"
                        id="pricing_due_date_id"
                        class="form-control"
                        v-model.trim="pricing_due_date"
                      />
                    </div>
                  </div>

                  <p></p>

                  <div class="row">
                    <div class="col-lg-12">
                      <label for="notes_id">Notes</label>
                      <textarea
                        name="notes"
                        cols="40"
                        rows="3"
                        id="notes_id"
                        class="form-control"
                        v-model.trim="notes"
                      ></textarea>
                    </div>
                  </div>

                  <p></p>

                  <h5 class="font-size-14">Files</h5>
                  <p></p>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="drag-area">
                        <div>
                          <div
                            :class="[
                              'dropZone',
                              dragging ? 'dropZone-over' : '',
                            ]"
                            @dragenter="dragging = true"
                            @dragleave="dragging = false"
                          >
                            <div class="dropZone-info" @drag="onChange">
                              <span
                                style="
                                  font-size: 21pt;
                                  margin-bottom: 15px;
                                  color: #bebebe;
                                "
                                class="fas fa-cloud-upload-alt dropZone-title"
                              ></span>
                              <span class="dropZone-title"
                                >Drag and drop files here</span
                              >
                              <span> Or </span>
                              <button
                                type="button"
                                class="
                                  btn btn-primary btn-sm btn-task
                                  mb-3
                                  mt-3
                                  removeFile
                                "
                                @click="fileInput.click()"
                              >
                                Browse files
                              </button>
                              <div class="dropZone-upload-limit-info">
                                <div>extension support: *</div>
                                <div>maximum file size: 5 MB</div>
                              </div>
                            </div>
                            <input
                              refs="fileInput"
                              type="file"
                              @change="onChange"
                              multiple
                            />
                          </div>
                        </div>
                      </div>

                      <template v-if="file">
                        <p></p>
                        <div
                          v-for="(fileData, index) in file"
                          :key="index"
                          class="file-list-item"
                        >
                          <a :href="fileData.file" target="_blank">
                            {{ fileData.name }}
                          </a>
                          <button
                            class="
                              btn btn-link
                              text-danger text-gradient
                              px-3
                              mb-0
                            "
                            :disabled="loadingAction"
                            type="button"
                            @click="deleteFile(fileData)"
                          >
                            <i
                              class="far fa-trash-alt me-2"
                              aria-hidden="true"
                            ></i
                            >Delete
                          </button>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <template v-if="oppFiles">
                        <p v-if="!file"></p>
                        <div
                          v-for="(fileData, index) in oppFiles"
                          :key="index"
                          class="file-list-item"
                        >
                          <a :href="fileData.file" target="_blank">
                            {{ fileData.filename }}
                          </a>

                          <button
                            class="
                              btn btn-link
                              text-danger text-gradient
                              px-3
                              mb-0
                            "
                            :disabled="loadingAction"
                            type="button"
                            @click="deleteFileOpp(fileData)"
                          >
                            <i
                              class="far fa-trash-alt me-2"
                              aria-hidden="true"
                            ></i
                            >Delete
                          </button>
                        </div>
                      </template>
                    </div>
                  </div>
                  <p></p>
                </template>
                <template v-if="step > 1 && !isEdit">
                  <p></p>
                  <div class="row">
                    <div class="col-lg-6">
                      <label for="broker_name">Source*</label>
                      <v-select
                        v-model.trim="source_type"
                        :options="[
                          { label: 'INDIRECT', code: 'INDIRECT' },
                          { label: 'DIRECT', code: 'DIRECT' },
                        ]"
                      ></v-select>
                    </div>
                  </div>
                  <p></p>
                  <template
                    v-if="source_type && source_type.code === 'INDIRECT'"
                  >
                    <p></p>
                    <div class="row">
                      <div class="col-lg-6">
                        <label for="broker_name"
                          >Source Name*</label
                        >

                        <v-select
                          v-model="source_name"
                          :options="sourceList"
                          aria-placeholder="Broker and Consultant Search"
                          placeholder="Broker and Consultant Search"
                        ></v-select>
                      </div>
                    </div>
                    <p></p>
                    <p></p>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row">
                          <div class="col-lg-3">
                            <label for="broker_fee"
                              >Source Fee</label
                            >
                            <currency-input
                              v-model="source_fee"
                              currency="USD"
                              locale="us"
                              class="form-control"
                            />
                          </div>
                          <div class="col-lg-6">
                            <label for="fee_determinant">Fee Determinant</label>

                            <div class="row">
                              <div class="col-12">
                                <b-form-radio-group
                                  style="display: flex"
                                  id="checkbox-group"
                                  v-model="fee_determinant"
                                  name="selectedUsers"
                                >
                                  <b-form-radio
                                    id="fee_determinant_id"
                                    name="fee_determinant"
                                    value="Per_Therm"
                                    style="padding: 5px 35px 5px 3px"
                                  >
                                    Per Therm
                                  </b-form-radio>
                                  <b-form-radio
                                    id="fee_determinant_id"
                                    name="fee_determinant"
                                    value="Per_Dekatherm"
                                    style="padding: 5px 10px 5px 3px"
                                  >
                                    Per Dekatherm
                                  </b-form-radio>
                                </b-form-radio-group>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <label for="broker_fee">RFP ID</label>
                            <input
                              type="number"
                              name="source_fee"
                              id="source_fee_id"
                              class="form-control"
                              v-model.trim="source_rfp"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <p></p>
                    <template v-if="step > 2">
                      <p></p>
                      <div class="row">
                        <div class="col-lg-6">
                          <label for="broker_name"
                            >Estimated Annual Volume</label
                          >
                          <input
                            type="number"
                            placeholder="Enter annual volume..."
                            name="estimated_annual_volume"
                            id="estimated_annual_volume"
                            class="form-control"
                            v-model.trim="estimated_annual_volume"
                          />
                        </div>
                      </div>
                      <p></p>
                      <p></p>
                      <div class="row">
                        <div class="col-lg-6">
                          <label for="">Expected Close Date</label>
                          <date-range-picker
                            ref="picker"
                            class="w-100 mt-2"
                            :singleDatePicker="'single'"
                            v-model="expected_close_date"
                          >
                          </date-range-picker>
                        </div>
                      </div>
                      <p></p>
                      <label for="">Add Opportunity Supporting Files</label>
                      <p></p>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="drag-area">
                            <div>
                              <div
                                :class="[
                                  'dropZone',
                                  dragging ? 'dropZone-over' : '',
                                ]"
                                @dragenter="dragging = true"
                                @dragleave="dragging = false"
                              >
                                <div class="dropZone-info" @drag="onChange">
                                  <span
                                    style="
                                      font-size: 21pt;
                                      margin-bottom: 15px;
                                      color: #bebebe;
                                    "
                                    class="
                                      fas
                                      fa-cloud-upload-alt
                                      dropZone-title
                                    "
                                  ></span>
                                  <span class="dropZone-title"
                                    >Drag and drop files here</span
                                  >
                                  <span> Or </span>
                                  <button
                                    type="button"
                                    class="
                                      btn btn-primary btn-sm btn-task
                                      mb-3
                                      mt-3
                                      removeFile
                                    "
                                    @click="fileInput.click()"
                                  >
                                    Browse files
                                  </button>
                                  <div class="dropZone-upload-limit-info">
                                    <div>extension support: *</div>
                                    <div>maximum file size: 5 MB</div>
                                  </div>
                                </div>
                                <input
                                  refs="fileInput"
                                  type="file"
                                  @change="onChange"
                                  multiple
                                />
                              </div>
                            </div>
                          </div>

                          <template v-if="file">
                            <p></p>
                            <div
                              v-for="(fileData, index) in file"
                              :key="index"
                              class="file-list-item"
                            >
                              <a :href="fileData.file" target="_blank">
                                {{ fileData.name }}
                              </a>

                              <div
                                class="wrap-tag-checkbox"
                                style="display: flex"
                              >
                                <b-form-checkbox-group
                                  style="display: flex"
                                  id="checkbox-group"
                                  v-model="fileData.tags"
                                  name="selectedUsers"
                                >
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Credit_Support"
                                  >
                                    Credit Support
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Email"
                                  >
                                    Email
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Invoice"
                                  >
                                    Invoice
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Legal_Entities"
                                  >
                                    Legal Entities
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="LOA"
                                  >
                                    LOA
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="NDA"
                                  >
                                    NDA
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="RFP"
                                  >
                                    RFP
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Service_Locations"
                                  >
                                    Service Locations
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Usage"
                                  >
                                    Usage
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Utility_Accounts"
                                  >
                                    Utility Accounts
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                                <button
                                  class="
                                    btn btn-link
                                    text-danger text-gradient
                                    px-3
                                    mb-0
                                    ml-3
                                  "
                                  :disabled="loadingAction"
                                  type="button"
                                  @click="deleteFile(fileData)"
                                >
                                  <i
                                    class="far fa-trash-alt me-2"
                                    aria-hidden="true"
                                  ></i
                                  >Delete
                                </button>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <template v-if="oppFiles">
                            <p v-if="!file"></p>
                            <div
                              v-for="(fileData, index) in oppFiles"
                              :key="index"
                              class="file-list-item"
                            >
                              <a :href="fileData.file" target="_blank">
                                {{ fileData.filename }}
                              </a>

                              <button
                                class="
                                  btn btn-link
                                  text-danger text-gradient
                                  px-3
                                  mb-0
                                "
                                :disabled="loadingAction"
                                type="button"
                                @click="deleteFileOpp(fileData)"
                              >
                                <i
                                  class="far fa-trash-alt me-2"
                                  aria-hidden="true"
                                ></i
                                >Delete
                              </button>
                            </div>
                          </template>
                        </div>
                      </div>
                      <p></p>
                    </template>
                  </template>

                  <template v-if="source_type && source_type.code === 'DIRECT'">
                    <p></p>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row">
                          <div class="col-lg-6">
                            <label for="broker_name"
                              >Estimated Annual Volume</label
                            >
                            <input
                              type="number"
                              placeholder="Enter annual volume..."
                              name="estimated_annual_volume"
                              id="estimated_annual_volume"
                              class="form-control"
                              v-model.trim="estimated_annual_volume"
                            />
                          </div>
                          <div class="col-lg-6">
                            <b-form-radio-group
                              style="display: flex; padding-top: 30px"
                              id="checkbox-group"
                              v-model="fee_determinant_direct"
                              name="selectedUsers"
                            >
                              <b-form-radio
                                id="fee_determinant_id"
                                name="fee_determinant"
                                value="Per_Therm"
                                style="padding: 5px 35px 5px 3px"
                              >
                                Therms
                              </b-form-radio>
                              <b-form-radio
                                id="fee_determinant_id"
                                name="fee_determinant"
                                value="Per_Dekatherm"
                                style="padding: 5px 10px 5px 3px"
                              >
                                Dekatherms
                              </b-form-radio>
                            </b-form-radio-group>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p></p>
                    <p></p>
                    <div class="row">
                      <div class="col-lg-6">
                        <label for="">Expected Close Date</label>
                        <div class="row">
                          <div class="col-12">
                            <date-range-picker
                              ref="picker"
                              class="w-100 mt-2"
                              :singleDatePicker="'single'"
                              v-model="expected_close_date"
                            >
                            </date-range-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p></p>
                    <template v-if="step > 2">
                      <label for="">Add Opportunity Supporting Files</label>
                      <p></p>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="drag-area">
                            <div>
                              <div
                                :class="[
                                  'dropZone',
                                  dragging ? 'dropZone-over' : '',
                                ]"
                                @dragenter="dragging = true"
                                @dragleave="dragging = false"
                              >
                                <div class="dropZone-info" @drag="onChange">
                                  <span
                                    style="
                                      font-size: 21pt;
                                      margin-bottom: 15px;
                                      color: #bebebe;
                                    "
                                    class="
                                      fas
                                      fa-cloud-upload-alt
                                      dropZone-title
                                    "
                                  ></span>
                                  <span class="dropZone-title"
                                    >Drag and drop files here</span
                                  >
                                  <span> Or </span>
                                  <button
                                    type="button"
                                    class="
                                      btn btn-primary btn-sm btn-task
                                      mb-3
                                      mt-3
                                      removeFile
                                    "
                                    @click="fileInput.click()"
                                  >
                                    Browse files
                                  </button>
                                  <div class="dropZone-upload-limit-info">
                                    <div>extension support: *</div>
                                    <div>maximum file size: 5 MB</div>
                                  </div>
                                </div>
                                <input
                                  refs="fileInput"
                                  type="file"
                                  @change="onChange"
                                  multiple
                                />
                              </div>
                            </div>
                          </div>

                          <template v-if="file">
                            <p></p>
                            <div
                              v-for="(fileData, index) in file"
                              :key="index"
                              class="file-list-item"
                            >
                              <a :href="fileData.file" target="_blank">
                                {{ fileData.name }}
                              </a>

                              <div
                                class="wrap-tag-checkbox"
                                style="display: flex"
                              >
                                <b-form-checkbox-group
                                  style="display: flex"
                                  id="checkbox-group"
                                  v-model="fileData.tags"
                                  name="selectedUsers"
                                >
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Credit_Support"
                                  >
                                    Credit Support
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Email"
                                  >
                                    Email
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Invoice"
                                  >
                                    Invoice
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Legal_Entities"
                                  >
                                    Legal Entities
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="LOA"
                                  >
                                    LOA
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="NDA"
                                  >
                                    NDA
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="RFP"
                                  >
                                    RFP
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Service_Locations"
                                  >
                                    Service Locations
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Usage"
                                  >
                                    Usage
                                  </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="Utility_Accounts"
                                  >
                                    Utility Accounts
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                                <button
                                  class="
                                    btn btn-link
                                    text-danger text-gradient
                                    px-3
                                    mb-0
                                    ml-3
                                  "
                                  :disabled="loadingAction"
                                  type="button"
                                  @click="deleteFile(fileData)"
                                >
                                  <i
                                    class="far fa-trash-alt me-2"
                                    aria-hidden="true"
                                  ></i
                                  >Delete
                                </button>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <template v-if="oppFiles">
                            <p v-if="!file"></p>
                            <div
                              v-for="(fileData, index) in oppFiles"
                              :key="index"
                              class="file-list-item"
                            >
                              <a :href="fileData.file" target="_blank">
                                {{ fileData.filename }}
                              </a>

                              <button
                                class="
                                  btn btn-link
                                  text-danger text-gradient
                                  px-3
                                  mb-0
                                "
                                :disabled="loadingAction"
                                type="button"
                                @click="deleteFileOpp(fileData)"
                              >
                                <i
                                  class="far fa-trash-alt me-2"
                                  aria-hidden="true"
                                ></i
                                >Delete
                              </button>
                            </div>
                          </template>
                        </div>
                      </div>
                      <p></p>
                    </template>
                  </template>
                </template>

                <div class="row">
                  <div class="col-12" v-if="step !== 5 && !isEdit">
                    <div class="p-2 bd-highlight mt-3 text-center">
                      <button
                        type="button"
                        class="btn btn-success waves-effect waves-light"
                        name="save"
                        value="save"
                        :disabled="isDisabledNext || loadingAction"
                        @click="onClickNext()"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                  <div v-if="isEdit" class="col-12 text-center">
                    <div class="d-flex bd-highlight mb-3">
                      <div class="p-2 bd-highlight">
                        <button
                          type="button"
                          class="btn btn-success waves-effect waves-light"
                          name="save"
                          value="save"
                          :disabled="loadingAction"
                          @click="typeClick = 'opp'"
                        >
                          Save
                        </button>
                      </div>

                      <div class="p-2 bd-highlight">
                        <router-link
                          class="btn btn-light waves-effect"
                          :to="'/mpg/opportunities'"
                          >Cancel</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>

    <b-modal id="tag-create" hide-footer body-class="p-0">
      <template #modal-header>
        <h5 class="modal-title">Tags Creation</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          :disabled="loadingAction"
          @click="$bvModal.hide('tag-create')"
        ></button>
      </template>

      <form
        @submit.prevent="onSubmitTag"
        novalidate
        :class="
          submittedTag ? 'needs-validation was-validated' : 'needs-validation'
        "
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-10">
              <div class="mb-3">
                <label for="name_id">Name*</label>
                <input
                  type="text"
                  name="name"
                  id="name_id"
                  class="form-control"
                  required=""
                  v-model.trim="$v.tag_name.$model"
                />

                <div
                  v-if="submittedTag && !$v.tag_name.required"
                  class="invalid-tooltip"
                >
                  This field is required
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="mb-3">
                <label for="color_id">Color*</label>
                <div
                  class="picker-input"
                  v-click-outside-element="
                    showPicker ? (showPicker = false) : null
                  "
                >
                  <input
                    type="color"
                    required
                    v-model.trim="$v.color.$model"
                    class="form-control form-control-color"
                    @click.stop="showPicker = true"
                  />
                  <div
                    v-if="submittedTag && !$v.color.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div>
                  <div class="picker-box" v-if="showPicker">
                    <sketch-picker
                      @input="updateValue"
                      :value="color"
                      :preset-colors="[
                        '#f00',
                        '#00ff00',
                        '#00ff0055',
                        'rgb(201, 76, 76)',
                        'rgba(0,0,255,1)',
                        'hsl(89, 43%, 51%)',
                        'hsla(89, 43%, 51%, 0.6)',
                      ]"
                    ></sketch-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="description_id">Description</label>
                <textarea
                  name="description"
                  v-model.trim="$v.description.$model"
                  cols="40"
                  rows="3"
                  id="description_id"
                  class="form-control"
                  required
                ></textarea>
                <div
                  v-if="submittedTag && !$v.description.required"
                  class="invalid-tooltip"
                >
                  This field is required
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light waves-effect"
            data-bs-dismiss="modal"
            @click="$bvModal.hide('tag-create')"
            :disabled="loadingAction"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-success waves-effect waves-light"
            name="create_tag"
            value="create_tag"
            data-bs-dismiss="modal"
            :disabled="loadingAction"
          >
            Save
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { opportunityService } from '../services/opportunities.service'
import { authenticationService } from '../services/authentication.service'
import VueTagsInput from '@johmun/vue-tags-input'
import { required } from 'vuelidate/lib/validators'
import { router } from '../router'
import { utilService } from '../services/util.service'
import { Sketch } from 'vue-color'
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'

export default {
  name: 'AddOpportunities',
  components: {
    VueTagsInput,
    'sketch-picker': Sketch,
    DateRangePicker
  },
  data () {
    return {
      tag: '',
      source_rfp: '',
      tags: [],
      autocompleteItems: [],
      opportunity_name: '',
      broker_name: '',
      broker_fee: null,
      notes: '',
      source_name: '',
      source_fee: 0,
      sales_annual_volume_manual: '',
      sales_represented: '',
      pricing_due_date: '',
      credit_request: 'no',
      submitted: false,
      loading: true,
      error: '',
      openDefault: false,
      loadingAction: false,
      isEdit: false,
      detailEdit: null,
      color: '#222',
      tagName: '',
      closePicker: false,
      showPicker: false,
      source_type: null,
      description: '',
      tag_name: '',
      submittedTag: false,
      typeClick: '',
      oppFiles: [],
      file: [],
      dragging: false,
      fee_determinant: null,
      step: 1,
      estimated_annual_volume: '',
      expected_close_date: {},
      fee_determinant_direct: null,
      sourceList: [
        {
          label: 'Accenture',
          value: 'Accenture'
        },
        {
          label: 'Acclaim',
          value: 'Acclaim'
        },
        {
          label: 'Alternative Energy Source',
          value: 'Alternative Energy Source'
        },
        {
          label: 'Ameresco',
          value: 'Ameresco'
        },
        {
          label: 'Amerex',
          value: 'Amerex'
        },
        {
          label: 'Apollo Edison',
          value: 'Apollo Edison'
        },
        {
          label: 'APPI',
          value: 'APPI'
        },
        {
          label: 'Atlas',
          value: 'Atlas'
        },
        {
          label: 'Aurora Energy',
          value: 'Aurora Energy'
        },
        {
          label: 'Avion Energy',
          value: 'Avion Energy'
        },
        {
          label: 'BMark',
          value: 'BMark'
        },
        {
          label: 'BOX',
          value: 'BOX'
        },
        {
          label: 'Breaker Box',
          value: 'Breaker Box'
        },
        {
          label: 'Bright Power',
          value: 'Bright Power'
        },
        {
          label: 'Brent Phelts',
          value: 'Brent Phelts'
        },
        {
          label: 'Burton Energy',
          value: 'Burton Energy'
        },
        {
          label: 'Century Energy',
          value: 'Century Energy'
        },
        {
          label: 'Choice Energy',
          value: 'Choice Energy'
        },
        {
          label: 'Christopher Clark',
          value: 'Christopher Clark'
        },
        {
          label: 'Concord Energy',
          value: 'Concord Energy'
        },
        {
          label: 'Dream Energy',
          value: 'Dream Energy'
        },
        {
          label: 'E-Quantum',
          value: 'E-Quantum'
        },
        {
          label: 'Ecom Energy',
          value: 'Ecom Energy'
        },
        {
          label: 'Edison Energy',
          value: 'Edison Energy'
        },
        {
          label: 'EMEX',
          value: 'EMEX'
        },
        {
          label: 'Enel X',
          value: 'Enel X'
        },
        {
          label: 'Enerconnex',
          value: 'Enerconnex'
        },
        {
          label: 'Energy Advisory Service',
          value: 'Energy Advisory Service'
        },
        {
          label: 'Energy Auction Exchange',
          value: 'Energy Auction Exchange'
        },
        {
          label: 'Energy Edge',
          value: 'Energy Edge'
        },
        {
          label: 'Energy Professionals',
          value: 'Energy Professionals'
        },
        {
          label: 'Energy Vision',
          value: 'Energy Vision'
        },

        {
          label: 'Enerworld',
          value: 'Enerworld'
        },
        {
          label: 'Engie',
          value: 'Engie'
        },
        {
          label: 'Eric Ryan Corporation',
          value: 'Eric Ryan Corporation'
        },
        {
          label: 'Evolution Energy Partners',
          value: 'Evolution Energy Partners'
        },
        {
          label: 'Expense Reduction Analysts',
          value: 'Expense Reduction Analysts'
        },
        {
          label: 'Infinity Power Partners',
          value: 'Infinity Power Partners'
        },
        {
          label: 'FC Stone',
          value: 'FC Stone'
        },
        {
          label: 'Gabel Associates',
          value: 'Gabel Associates'
        },
        {
          label: 'Good Energy',
          value: 'Good Energy'
        },
        {
          label: 'Ideal Energy',
          value: 'Ideal Energy'
        },
        {
          label: 'Indiana Energy',
          value: 'Indiana Energy'
        },
        {
          label: 'Infinite Energy',
          value: 'Infinite Energy'
        },
        {
          label: 'JMI Consultants',
          value: 'JMI Consultants'
        },
        {
          label: 'Kinect Energy',
          value: 'Kinect Energy'
        },
        {
          label: 'Koch Energy Services',
          value: 'Koch Energy Services'
        },
        {
          label: 'Legend Energy',
          value: 'Legend Energy'
        },
        {
          label: 'Maverick',
          value: 'Maverick'
        },
        {
          label: 'MSI Utilities',
          value: 'MSI Utilities'
        },
        {
          label: 'Nania Energy',
          value: 'Nania Energy'
        },
        {
          label: 'Navigate Power',
          value: 'Navigate Power'
        },

        {
          label: 'NUS Consulting',
          value: 'NUS Consulting'
        },
        {
          label: 'Our Energy Manager',
          value: 'Our Energy Manager'
        },
        {
          label: 'Power Brokers',
          value: 'Power Brokers'
        },
        {
          label: 'Power Kiosk',
          value: 'Power Kiosk'
        },
        {
          label: 'Premier Power Broker',
          value: 'Premier Power Broker'
        },
        {
          label: 'Priority Power',
          value: 'Priority Power'
        },
        {
          label: 'Progressive Energy',
          value: 'Progressive Energy'
        },
        {
          label: 'PRX Energy',
          value: 'PRX Energy'
        },
        {
          label: 'Satori Energy',
          value: 'Satori Energy'
        },
        {
          label: 'Schneider',
          value: 'Schneider'
        },
        {
          label: 'Sentry Energy',
          value: 'Sentry Energy'
        },
        {
          label: 'Siemens',
          value: 'Siemens'
        },
        {
          label: 'Southeastern Energy Services',
          value: 'Southeastern Energy Services'
        },
        {
          label: 'Southern Energy Alliance',
          value: 'Southern Energy Alliance'
        },
        {
          label: 'Taurus',
          value: 'Taurus'
        },
        {
          label: 'Team Energy',
          value: 'Team Energy'
        },
        {
          label: 'TECO Partners',
          value: 'TECO Partners'
        },
        {
          label: 'TES Energy',
          value: 'TES Energy'
        },
        {
          label: 'Titan Energy',
          value: 'Titan Energy'
        },
        {
          label: 'Total Utility Management Services',
          value: 'Total Utility Management Services'
        },
        {
          label: 'TPI',
          value: 'TPI'
        },
        {
          label: 'Tradition Energy',
          value: 'Tradition Energy'
        },
        {
          label: 'Trane',
          value: 'Trane'
        },
        {
          label: 'Transparent Energy',
          value: 'Transparent Energy'
        },
        {
          label: 'Twin City',
          value: 'Twin City'
        },
        {
          label: 'Unified Energy',
          value: 'Unified Energy'
        },
        {
          label: 'United Power Consultants',
          value: 'United Power Consultants'
        },
        {
          label: 'US Energy',
          value: 'US Energy'
        },
        {
          label: 'Utility Elf',
          value: 'Utility Elf'
        },
        {
          label: 'Utility Rate Analysis',
          value: 'Utility Rate Analysis'
        }
      ]
    }
  },
  validations: {
    opportunity_name: { required },
    tag_name: { required },
    description: { required },
    color: { required },
    tags: {}
  },
  computed: {
    filteredItems () {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
    isDisabledNext () {
      switch (this.step) {
        case 1:
          return !this.opportunity_name || this.opportunity_name === ''
        case 2:
          if (this.source_type && this.source_type.code === 'INDIRECT') {
            return (
              !this.source_name ||
              this.source_name === ''
            )
          }
          return (
            !this.expected_close_date.startDate ||
            this.estimated_annual_volume === ''
          )
        default:
          return false
      }
    }
  },
  created () {
    if (this.$route.params.id && this.$route.params.id !== '') {
      this.isEdit = true
      opportunityService
        .getFileFile('opportunity-' + this.$route.params.id)
        .then((files) => {
          this.bidFiles = files.results
        })
    }

    utilService.getTag().then((tags) => {
      this.autocompleteItems = tags.results.map((e) => {
        e.text = e.name
        e.id = e.tag_id
        return e
      })
      if (this.isEdit) {
        this.loading = true
        opportunityService.getDataById(this.$route.params.id).then((rs) => {
          this.detailEdit = rs
          this.opportunity_name = rs.opportunity_name
          this.broker_name = rs.broker_name
          this.broker_fee = rs.broker_fee
          this.notes = rs.notes
          this.sales_annual_volume_manual = rs.sales_annual_volume_manual
          this.sales_represented = rs.sales_represented
          this.credit_request = rs.credit_request
          this.pricing_due_date = rs.pricing_due_date
          this.tags = rs.tags.map((e) => {
            e.text = e.name
            e.id = e.tag_id
            return e
          })
          this.loading = false
        })
      } else {
        this.loading = false
      }
    })
  },
  methods: {
    onClickNext () {
      this.step = this.step + 1
      if (this.step === 4) {
        const payload = {
          source_type: this.source_type.code,
          source_name: this.source_name.value,
          tags: this.tags.map((e) => e.id),
          opportunity_name: this.opportunity_name
        }
        if (this.source_type.code === 'INDIRECT') {
          payload.fee_determinant_indirect = true
          payload.fee_determinant_direct = false
          payload.source_rfp = this.source_rfp
          payload.source_fee = this.source_fee
          payload.dekatherms = this.fee_determinant === 'Per_Dekatherm'
          payload.estimated_annual_volume = Number(
            this.estimated_annual_volume
          )
          payload.expected_close_date = moment(
            this.expected_close_date.startDate
          ).format('YYYY-MM-DD')
        } else {
          payload.fee_determinant_indirect = false
          payload.fee_determinant_direct = true
          payload.dekatherms = this.fee_determinant_direct === 'Per_Dekatherm'
          payload.estimated_annual_volume = Number(
            this.estimated_annual_volume
          )
          payload.expected_close_date = moment(
            this.expected_close_date.startDate
          ).format('YYYY-MM-DD')
        }

        const type = authenticationService.currentContentTypeValue
        const contentType = type.find((e) => e.model === 'file').id
        this.loadingAction = true

        console.log(payload)
        opportunityService.add(payload).then(
          (rs) => {
            if (this.file.length > 0) {
              for (let i = 0; i < this.file.length; i++) {
                let formData = new FormData()
                formData.append('file', this.file[i])
                formData.append('filename', this.file[i].name)
                formData.append(
                  'object_id',
                  'opportunity-' + rs.opportunity_id
                )
                formData.append('content_type', contentType)
                opportunityService.uploadFile(formData).then(
                  (rs) => {},
                  (error) => {
                    this.$bvToast.toast('Error.', {
                      title: `Error. Cannot Upload File ${error}`,
                      variant: 'danger',
                      solid: true
                    })
                  }
                )
              }

              this.$nextTick(() => {
                if (this.typeClick === 'opp') {
                  router.push(
                    '/mpg/opportunities/' + rs.opportunity_id + '/details'
                  )
                } else {
                  router.push(
                    '/mpg/opportunities/' + rs.opportunity_id + '/details'
                  )
                }
              })
            } else {
              this.$nextTick(() => {
                if (this.typeClick === 'opp') {
                  router.push(
                    '/mpg/opportunities/' + rs.opportunity_id + '/details'
                  )
                } else {
                  router.push(
                    '/mpg/opportunities/' + rs.opportunity_id + '/details'
                  )
                }
              })
            }
          },
          (error) => {
            this.error = error
            this.loading = false
          }
        )
      }
    },
    onBlur () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.openDefault = false
        }, 500)
      })
    },
    updateValue (value) {
      this.color = value.hex
    },
    onSubmitTag () {
      this.submittedTag = true
      // stop here if form is invalid
      this.$v.description.$touch()
      this.$v.tag_name.$touch()
      this.$v.color.$touch()
      if (
        this.$v.description.$invalid ||
        this.$v.tag_name.$invalid ||
        this.$v.color.$invalid
      ) {
        return
      }
      //
      this.loadingAction = true
      const payload = {
        name: this.tag_name,
        color: this.color,
        description: this.description
      }
      utilService.addTag(payload).then((rs) => {
        this.autocompleteItems.push({
          text: rs.name,
          id: rs.tag_id
        })
        this.$bvModal.hide('tag-create')
      })
    },
    onSubmit () {
      this.submitted = true

      // stop here if form is invalid
      this.$v.opportunity_name.$touch()
      this.$v.tags.$touch()
      if (this.$v.opportunity_name.$invalid || this.$v.tags.$invalid) {
        return
      }
      const type = authenticationService.currentContentTypeValue
      const contentType = type.find((e) => e.model === 'file').id
      //
      this.loadingAction = true
      const payload = {
        tags: this.tags.map((e) => e.id),
        opportunity_name: this.opportunity_name,
        broker_name: this.broker_name,
        broker_fee: this.broker_fee,
        notes: this.notes,
        sales_represented: this.sales_represented,
        credit_request: this.credit_request
      }

      if (
        this.sales_annual_volume_manual &&
        this.sales_annual_volume_manual !== ''
      ) {
        payload['sales_annual_volume_manual'] = this.sales_annual_volume_manual
      }

      if (this.pricing_due_date && this.pricing_due_date !== '') {
        payload['pricing_due_date'] = this.pricing_due_date
      }
      if (this.isEdit) {
        opportunityService.update(payload, this.$route.params.id).then(
          (rs) => {
            if (this.file.length > 0) {
              for (let i = 0; i < this.file.length; i++) {
                let formData = new FormData()
                formData.append('file', this.file[i])
                formData.append('filename', this.file[i].name)
                formData.append(
                  'object_id',
                  'opportunity-' + this.$route.params.id
                )
                formData.append('content_type', contentType)
                opportunityService.uploadFile(formData).then(
                  (rs) => {},
                  (error) => {
                    this.$bvToast.toast('Error.', {
                      title: `Error. Cannot Upload File ${error}`,
                      variant: 'danger',
                      solid: true
                    })
                  }
                )
              }

              this.$nextTick(() => {
                this.loadingAction = false
                this.$router.go(-1)
              })
            } else {
              this.loadingAction = false
              this.$router.go(-1)
            }
          },
          (error) => {
            this.$bvToast.toast('Cannot update opportunity.', {
              title: `Error`,
              variant: 'danger'
            })
            this.error = error
            this.loadingAction = false
          }
        )
      } else {
        opportunityService.add(payload).then(
          (rs) => {
            if (this.file.length > 0) {
              for (let i = 0; i < this.file.length; i++) {
                let formData = new FormData()
                formData.append('file', this.file[i])
                formData.append('filename', this.file[i].name)
                formData.append(
                  'object_id',
                  'opportunity-' + rs.opportunity_id
                )
                formData.append('content_type', contentType)
                opportunityService.uploadFile(formData).then(
                  (rs) => {},
                  (error) => {
                    this.$bvToast.toast('Error.', {
                      title: `Error. Cannot Upload File ${error}`,
                      variant: 'danger',
                      solid: true
                    })
                  }
                )
              }

              this.$nextTick(() => {
                if (this.typeClick === 'opp') {
                  router.push(
                    '/mpg/opportunities/' + rs.opportunity_id + '/details'
                  )
                } else {
                  router.push(
                    '/mpg/opportunities/' + rs.opportunity_id + '/bid/new'
                  )
                }
              })
            } else {
              this.$nextTick(() => {
                if (this.typeClick === 'opp') {
                  router.push(
                    '/mpg/opportunities/' + rs.opportunity_id + '/details'
                  )
                } else {
                  router.push(
                    '/mpg/opportunities/' + rs.opportunity_id + '/bid/new'
                  )
                }
              })
            }
          },
          (error) => {
            this.error = error
            this.loading = false
          }
        )
      }
    },
    onChange (e) {
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        this.dragging = false
        return
      }

      this.createFile(files)
    },
    createFile (files) {
      // if (!file.type.match('text.*')) {
      //   alert('please select txt file');
      //   this.dragging = false;
      //   return;
      // }

      const inValidFile = []

      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 5000000) {
          inValidFile.push(files[i])
        }
      }

      if (inValidFile.length > 0) {
        this.$bvToast.toast('Error.', {
          title: `Please check file size no over 5 MB.`,
          variant: 'danger',
          solid: true
        })
        this.dragging = false
        return
      }

      this.file = [...this.file, ...files]
      this.dragging = false
    },
    deleteFile (fileData) {
      this.file = this.file.filter((e) => e.name !== fileData.name)
    },
    deleteFileBid (file) {
      opportunityService
        .deleteFile(file.file_id)
        .then((rs) => {
          this.$bvToast.toast('Delete successfully.', {
            title: `Update`,
            variant: 'primary',
            solid: true
          })
          this.bidData = this.bidData.filter((e) => e.file_id !== file.file_id)
        })
        .catch(() => {
          this.$bvToast.toast('Cannot delete this file.', {
            title: `Error`,
            variant: 'danger',
            solid: true
          })
        })
    }
  }
}
</script>

<style>
.wrap-tag-checkbox .custom-control {
  margin-top: 9px;
  margin-right: 15px;
}

.wrap-tag-checkbox .custom-control label {
  vertical-align: text-top;
}
</style>

<style scoped>
.dropZone {
  width: 100%;
  height: 300px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px dashed #0060ae;
}

.dropZone:hover .dropZone-title {
  color: #0060ae;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #008dff1f;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}

.picker-input {
  position: relative;
  z-index: 98;
  width: 50px;
}
.picker-box {
  position: absolute;
  top: 47px;
  left: 1px;
  z-index: 99;
}
.picker-fade {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 97;
  left: 0;
  top: 0;
}

.form-control-color {
  padding: 0.47rem !important;
  height: 39px !important;
}

.file-list-item {
  margin-bottom: 7px;
  background: #eee;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AddOpportunities.vue